import SlopeReportMapJSON from "./SlopeReportMapJSON";
import esriRequest from "@arcgis/core/request";
import DownloadBlob from "./DownloadBlob";

import config from "../config";

export default async function(
  mSlopeNo,
  geometry,
  filename = "SlopeReport.pdf",
  type = "application/pdf"
) {
  const mURL =
    config.serverUrl +
    "/rest/services/PrintTool/CustomPrintingService/GPServer/Export%20Web%20Map/execute";

  let webmapJson = SlopeReportMapJSON(geometry);
  let formData = new FormData();
  formData.append("Web_Map_as_JSON", JSON.stringify(webmapJson));
  formData.append("Format", "JPG");
  formData.append("Layout_Template", "MAP_ONLY");
  formData.append("f", "json");
  let result = await esriRequest(mURL, {
    body: formData,
    method: "post",
    responseType: "json",
  });

  let slopePrintUrl = result.data.results[0].value.url;

  formData = new FormData();
  formData.append("slopenos", mSlopeNo);
  formData.append("slopeplans", slopePrintUrl);
  let pdfData = await fetch(config.slopeReportUrl, {
    method: "POST",
    body: formData,
  });
  let data = await pdfData.blob();
  DownloadBlob(data, filename, type);
}
